export default "__VITE_ASSET__DFx3DavW__"